import React from "react";
import Th_title from "../Th_title";
import {displayText} from "../../packages/asset/mng/info/shared/assetDetailKv";
export {DetailKvListValue} from "./DetailKvListValue";
export {KV_LIST_TYPES, getKvListLabel} from "./detailKvListLabels";

/** 항상 읽기 전용 KV 셀 (등록일시 등) */
export function DetailKvReadOnly({label, value, type, colspan = 1, className = "fieldset-td"}) {
    return (
        <>
            <th className="fieldset-th simms-detail-th truncate">{label}</th>
            <td {...(colspan > 1 ? {colSpan: colspan} : {})} className={className}>
                {displayText(value, type)}
            </td>
        </>
    );
}

/**
 * 보기/수정 전환 KV 필드. isEditing && edit가 있을 때만 Th_title+입력 컴포넌트.
 */
export function DetailKvField({
    isEditing,
    label,
    value,
    type,
    required,
    colspan = 1,
    className = "fieldset-td",
    auth,
    edit,
}) {
    if (isEditing && edit) {
        return (
            <Th_title
                title={label}
                colspan={colspan}
                required={required}
                className={className}
                auth={auth}
            >
                {edit}
            </Th_title>
        );
    }
    return (
        <>
            <th className="fieldset-th simms-detail-th truncate">
                {label}
                {required && <span className="c-red ml-1">*</span>}
            </th>
            <td {...(colspan > 1 ? {colSpan: colspan} : {})} className={className}>
                {displayText(value, type)}
            </td>
        </>
    );
}

